import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const ReportFilter = ({
    selectedOptions,
    setSelectedOptions,
    partials,
    setCurrentPage,
}) => {
    const { t } = useTranslation();

    const [category, setCategory] = useState([]);
    const [status,   setStatus]   = useState([]);
    const [trackId,  setTrackId]  = useState(selectedOptions.trackId || "");

    const categoryOptions = partials.data?.categories?.map((c) => ({
        label: t(c.label),
        value: c.value,
    })) ?? [];

    const statusOptions = partials.data?.statuses?.map((s) => ({
        label: t(s.label),
        value: s.value,
    })) ?? [];

    const handleSearch = () => {
        setCurrentPage(1);
        setSelectedOptions({
            ...selectedOptions,
            selectedCategory: category.map((o) => o.value),
            selectedStatus:   status.map((o) => o.value),
            trackId,
        });
    };

    const handleReset = () => {
        setCurrentPage(1);
        setCategory([]);
        setStatus([]);
        setTrackId("");
        setSelectedOptions({ trackId: "", selectedCategory: "", selectedStatus: "" });
    };

    return (
        <div className="filter_Section">
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="right_search_div">
                        <label>{t("report_id")}</label>
                        <input
                            type="text"
                            className="form-control"
                            value={trackId}
                            placeholder={t("report_id")}
                            onChange={(e) => setTrackId(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="right_search_div">
                        <label>{t("report_category")}</label>
                        <Select
                            value={category}
                            onChange={setCategory}
                            options={categoryOptions}
                            isMulti
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="right_search_div">
                        <label>{t("report_status")}</label>
                        <Select
                            value={status}
                            onChange={setStatus}
                            options={statusOptions}
                            isMulti
                        />
                    </div>
                </div>
                <div className="col-md-2 mt-4">
                    <div className="right_search_div d-flex gap-1">
                        <button className="btn btn-primary"   onClick={handleSearch}>{t("search")}</button>
                        <button className="btn btn-secondary" onClick={handleReset}>{t("reset")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportFilter;
